import React from 'react';

import { LayoutContent } from './LayoutContent';

export const Page = (props) => {
	const { children } = props;
	return <LayoutContent {...props}>{children}</LayoutContent>;
};
